<ng-container *ngIf="!loading, else isLoading">
  <mat-tab-group 
    mat-stretch-tabs="false"
    mat-align-tabs="start"
    dynamicHeight
    animationDuration='0ms'
    [(selectedIndex)]="selectedTab">
    <!-- Sorts Tab -->
    <mat-tab *ngIf="canViewSortScanReports">
      <ng-template mat-tab-label>
        <span class="tab-label">Sorts</span>
      </ng-template>
      <ng-template matTabContent>
        <app-sort-scans-reports [user]="user"></app-sort-scans-reports>
      </ng-template>
    </mat-tab>

    <!-- Pickups Tab -->
    <mat-tab *ngIf="canViewPickupScanReports">
      <ng-template mat-tab-label>
        <span class="tab-label">Pickups</span>
      </ng-template>
      <ng-template matTabContent>
        <app-pickup-scans-reports [user]="user"></app-pickup-scans-reports>
      </ng-template>
    </mat-tab>
  </mat-tab-group>
</ng-container>
<ng-template #isLoading>
  <div class='align-center mt--lg'>
    <app-loading></app-loading>
  </div>
</ng-template>
